import { useMemo } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { selectAllSalesTeamUsers } from '../slice'
import { useSelector } from 'react-redux'
import { useCheckAdminPermissions } from '@user/store/authorization/permissions/useCheckPermissions'
import { SettingsAdminPermOps } from '@user/store/authorization'

export const useSelectUsersForAssignment = (
  entityType: ENTITY_TYPES,
  salesTeamId: number,
  showInactiveUsers: boolean = false,
  alwaysIncludeUserId?: string,
) => {
  const allUsers = useSelector(selectAllSalesTeamUsers)

  const [showAdminUsers] = useCheckAdminPermissions(SettingsAdminPermOps)

  return useMemo(() => {
    return allUsers
      .filter((user) => showInactiveUsers || user.isActive)
      .filter(
        (u) =>
          u.salesTeamId === salesTeamId &&
          (entityType === ENTITY_TYPES.Lead
            ? u.canOwnLeads
            : u.canOwnOpportunities),
      )
      .filter((u) =>
        !showAdminUsers
          ? u.positionName !== 'Admin' ||
            (!!alwaysIncludeUserId && u.userId === alwaysIncludeUserId)
          : u,
      )
  }, [
    allUsers,
    entityType,
    salesTeamId,
    showAdminUsers,
    showInactiveUsers,
    alwaysIncludeUserId,
  ])
}
